import React from 'react'
import { DatePicker } from '../DatePicker'
import style from './style.module.scss'

type Props = {
    startDate: string
    endDate: string
    setStartDate: Function
    setEndDate: Function
    handleDateChange: Function
}

export const DateRanges: React.FC<Props> = ({
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleDateChange,
}) => {
    return (
        <div className={style.dateRanges}>
            <p className={style.title}>Sélectionner une période</p>

            <DatePicker
                id="starDate"
                label="Du"
                date={startDate}
                onChange={(val: any) => handleDateChange(val, setStartDate, 'start')}
            />
            <DatePicker
                id="endDate"
                label="Au"
                date={endDate}
                onChange={(val: any) => handleDateChange(val, setEndDate, 'end')}
            />
        </div>
    )
}

export default DateRanges
